import React from 'react';
import {
  StructuredTaskField,
  StructuredTaskFieldRow,
  StructuredTaskSection,
} from '../../../../common/components/StructuredTaskDetails';
import { Resource } from '../../../../common/constants/resource';
import { TRLScore } from '../../../tasks/types/trl';
import { valueToString } from '../../utilities/formattingUtilities';
import styles from './TRLScoresSection.module.scss';

function formatNoScoreReason(noScoreReason: string) {
  switch (noScoreReason) {
    case Resource.TRL_SCORE_REASON_SUBJECT_DECEASED_KEY:
      return Resource.TRL_SCORE_REASON_SUBJECT_DECEASED_VALUE;
    default:
      return noScoreReason;
  }
}

export const RenderScoresSection = ({
  score,
  onFileSince,
}: {
  score: TRLScore;
  onFileSince: number;
}) => {
  const scoreCodes = score.scoreCodes;
  const hasScoreCodes = scoreCodes.length > 0;
  const noScoreReason = formatNoScoreReason(score.reason);
  const noScoreText = noScoreReason
    ? `${Resource.TRL_SCORE_NO_SCORE} — ${noScoreReason}`
    : Resource.TRL_SCORE_NO_SCORE;

  return (
    <StructuredTaskSection title={Resource.TRL_SCORE_SUBTITLE}>
      <StructuredTaskFieldRow>
        {hasScoreCodes ? (
          <StructuredTaskField
            label={Resource.TRL_SCORE_SCORE}
            value={valueToString(score.score)}
            emphasized
          />
        ) : (
          <div className={styles.NoScoreField}>
            <div className={styles.NoScoreIcon}>-</div>
            <div className={styles.NoScoreText}>
              <span className={styles.NoScoreLabel}>
                {Resource.TRL_SCORE_SCORE}
              </span>
              <span className={styles.NoScoreReason}>
                <span className={styles.NoScoreDot} />
                {noScoreText}
              </span>
            </div>
          </div>
        )}
        <StructuredTaskField
          label={Resource.TRL_CREDIT_ON_FILE_SINCE}
          value={valueToString(onFileSince)}
        />
      </StructuredTaskFieldRow>
    </StructuredTaskSection>
  );
};
